import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { COVERAGE } from '@/libs/constants';
import { formatPriceWithCurrency } from '@/libs/helpers/utils';
import { useInsuranceStyles } from '../styles';
import { useOfferBlockStyles } from './offerBlockStyles';
const DelayCompensation = () => {
    const classes = useOfferBlockStyles();
    return (_jsxs(_Fragment, { children: [formatPriceWithCurrency(COVERAGE.DELAY_PER_HOUR, 'rub'), _jsx("span", { className: classes.perHour, children: "/\u0447\u0430\u0441" })] }));
};
const coverageItems = [
    {
        label: 'Задержка рейса',
        condition: `Более ${COVERAGE.MIN_DELAY_HOURS} часов по любой причине`,
        compensation: _jsx(DelayCompensation, {}),
    },
    {
        label: 'Отмена рейса',
        condition: 'По любой причине после задержки',
        compensation: formatPriceWithCurrency(COVERAGE.CANCELLATION, 'rub'),
    },
    {
        label: 'Перенаправление рейса',
        condition: 'Посадка в другом аэропорту',
        compensation: formatPriceWithCurrency(COVERAGE.REDIRECT, 'rub'),
    },
];
export const OfferBlock = memo(() => {
    const classes = useOfferBlockStyles();
    const insuranceClasses = useInsuranceStyles();
    return (_jsxs("div", { className: insuranceClasses.root, children: [_jsx("h3", { className: insuranceClasses.title, children: "\u041F\u043E\u043A\u0440\u044B\u0442\u0438\u0435 \u043D\u0430 \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0437\u0430\u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E" }), _jsx("div", { className: classes.coverageList, children: coverageItems.map(({ label, condition, compensation }) => (_jsxs("div", { className: classes.coverageItem, children: [_jsxs("div", { className: classes.coverageInfo, children: [_jsx("span", { className: classes.coverageLabel, children: label }), _jsx("span", { className: classes.coverageCondition, children: condition })] }), _jsx("span", { className: classes.coverageAmount, children: compensation })] }, label))) })] }));
});
